import React, { Component } from 'react';
import AdvisorListingsTable from './AdvisorListingsTable';
import { connect } from 'react-redux';
import {
  fetchAdminAdvisorListings,
  searchAdminAdvisorListings,
} from '../../state/actions/advisor';
import Pagination from './../../common/components/Pagination';
import { CircularProgress, Switch } from '@material-ui/core';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CustomDatePicker } from './../../common/utils/helpers';
import withSizes from 'react-sizes';

class AdvisorListings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalAdvisorListings: 134155463264,
      totalListingsOverNdays: 13412425,
      totalApproved: 13415245235,
      totalPending: 1341252345,
      loading: false,
      advisorSearchString: '',
      searchPlaceholder: 'Advisor Name',
      status: '',
      byId: false,
      startDate: null,
      endDate: null,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.fetchAdminAdvisorListings();
  }

  setStartDate(startDate) {
    this.setState({ startDate });
  }

  setEndDate(endDate) {
    this.setState({ endDate });
  }
  setAdvisorSearchString = searchString => {
    this.setState({ advisorSearchString: searchString });
  };

  advisorSearch = async e => {
    e.preventDefault();
    const {
      byId,
      advisorSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    if (byId) {
      this.props.searchAdminAdvisorListings(
        startDate,
        endDate,
        advisorSearchString,
        status,
        byId,
      );
    } else {
      this.props.searchAdminAdvisorListings(
        startDate,
        endDate,
        advisorSearchString,
        status,
      );
    }
  };

  advisorFilter = status => {
    const { byId, advisorSearchString, startDate, endDate } = this.state;
    if (byId) {
      this.props.searchAdminAdvisorListings(
        startDate,
        endDate,
        advisorSearchString,
        status,
        byId,
      );
    } else {
      this.props.searchAdminAdvisorListings(
        startDate,
        endDate,
        advisorSearchString,
        status,
      );
    }
  };

  handleFilterChange = e => {
    const status = e.target.value;
    this.setState({ status });
    this.advisorFilter(status);
  };

  onSwitch = async e => {
    const { checked } = e.target;
    this.setState({
      byId: checked,
      searchPlaceholder: checked ? 'Advosor ID' : 'Advisor Name',
    });
  };

  onPageChange = page => {
    const {
      byId,
      advisorSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    if (typeof page === 'number') {
      this.setState({ loading: true });
      this.props.searchAdminAdvisorListings(
        startDate,
        endDate,
        advisorSearchString,
        status,
        byId,
        page,
      );
    }
  };

  onPreviousPage = () => {
    const {
      byId,
      advisorSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    this.setState({ loading: true });
    this.props.searchAdminAdvisorListings(
      startDate,
      endDate,
      advisorSearchString,
      status,
      byId,
      this.props.pageNumber - 1,
    );
  };

  onNextPage = () => {
    const {
      byId,
      advisorSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    this.setState({ loading: true });
    this.props.searchAdminAdvisorListings(
      startDate,
      endDate,
      advisorSearchString,
      status,
      byId,
      this.props.pageNumber + 1,
    );
  };

  render() {
    const {
      adminAdvisorListings: allListings,
      pageNumber,
      pageSize,
      totalCount,
      loadingAdvisorListings,
      isMobile,
      isTablet,
    } = this.props;
    const { byId, searchPlaceholder, startDate, endDate } = this.state;
    return (
      <div className="admin-custom">
        <div className="ml-lg-5">
          <h1>Advisor Listings Overview</h1>
          <div className="w-50 my-3 border"></div>
          <div className="d-flex flex-wrap mb-5">
            <div className="d-flex flex-column justify-content-around w-100 w-lg-30 w-md-30 text-center bg-white shadow rounded-1 p-4 m-2">
              <p className="h6 mb-4">Total Advisor Listings</p>
              <div className="h2 font-weight-bold text-primary">
                {loadingAdvisorListings ? (
                  <CircularProgress color="primary" size={'1rem'} />
                ) : (
                  totalCount
                )}
              </div>
            </div>
            <div className="d-block d-lg-none d-md-none w-100"></div>
            <div className="d-flex justify-content-around w-100 w-lg-60 w-md-60 text-center bg-white shadow rounded-1 p-2 m-2">
              <div className="d-flex flex-column justify-content-around">
                <p className="h6 mb-4">From</p>
                <div className="input-group px-2">
                  <DatePicker
                    todayButton="Today"
                    selected={startDate}
                    onChange={date => this.setStartDate(date)}
                    isClearable
                    customInput={<CustomDatePicker ref={this.ref} />}
                    withPortal={isMobile || isTablet}
                  />
                </div>
              </div>
              <div className="d-flex flex-column justify-content-around">
                <p className="h6 mb-4">To</p>
                <div className="input-group">
                  <DatePicker
                    todayButton="Today"
                    selected={endDate}
                    onChange={date => this.setEndDate(date)}
                    isClearable
                    customInput={<CustomDatePicker ref={this.ref} />}
                    withPortal={isMobile || isTablet}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-50 my-3 border"></div>
          <div className=" ml-3">
            <Switch
              color="primary"
              name="renewal"
              value={byId}
              checked={byId}
              onChange={e => this.onSwitch(e)}
            />
            {byId ? 'By Advisor ID' : 'By Advisor Name'}
          </div>
          <div className="d-flex flex-nowrap my-4">
            <div className="form-inline w-70">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={searchPlaceholder}
                  aria-label={searchPlaceholder}
                  aria-describedby="basic-addon2"
                  onChange={event =>
                    this.setAdvisorSearchString(event.target.value)
                  }
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline btn-admin-primary"
                    type="button"
                    onClick={this.advisorSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <select
              className="browser-default custom-select w-30"
              value={this.state.status}
              onChange={this.handleFilterChange}
            >
              <option value="">See All</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="ChangesRequired">Changes Required</option>
              <option value="Draft">Draft</option>
              <option value="Declined">Declined</option>
              <option value="Deleted">Deleted</option>
            </select>
          </div>
          <div className="d-flex justify-content-between w-lg-60 w-md-60 mb-3">
            <p className="h7 font-weight-normal m-0">Legend: &nbsp;</p>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-danger mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Yet approved</p>
            </div>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-warning mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Approval In progress</p>
            </div>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-success mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Approved</p>
            </div>
          </div>
          <div className="profiles-table">
            <AdvisorListingsTable
              listings={allListings}
              loadingAdvisorListings={loadingAdvisorListings}
            />
            <div className="d-flex justify-content-center my-3">
              <Pagination
                currentPage={pageNumber}
                pageSize={pageSize}
                totalItem={totalCount}
                onPageChange={this.onPageChange}
                onPreviousPage={this.onPreviousPage}
                onNextPage={this.onNextPage}
                hideComponent={loadingAdvisorListings ? 'd-none' : ''}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapSizesToProps = sizes => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
});

export default withSizes(mapSizesToProps)(
  connect(
    state => ({
      loadingAdvisorListings: state.advisor.loadingAdvisorListings,
      adminAdvisorListings: state.advisor.adminAdvisorListings,
      pageNumber: state.advisor.pageNumber,
      pageSize: state.advisor.pageSize,
      totalCount: state.advisor.totalCount,
    }),
    { fetchAdminAdvisorListings, searchAdminAdvisorListings },
  )(AdvisorListings),
);
